export const pin = () => (
  <path
    d="M15.173 15.173L21 21M1.887 8.139l6.252-6.252.93.93a2 2 0 010 2.829l-.148.148 5.47 3.908.547-.547a3 3 0 014.243 0l1.005 1.005L10.16 20.186 9.155 19.18a3 3 0 010-4.243l.547-.547-3.907-5.47-.15.148a2 2 0 01-2.828 0l-.93-.93z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
